import React from 'react';
import PropTypes from 'prop-types';
import { prettyLocalDate } from '../../../lib/time';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 4,
    borderColor: '#b5b5b5',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: '1rem',
    color: '#000000',
    padding: '.8rem',
  },
  inner: {
    minWidth: 300,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

const PlanSummary = ({plan}) => {
  const classes = useStyles();
  const billingDate = prettyLocalDate(plan.first_billing_date);
  var dueToday = '0.00';
  var dueLater = plan.price;
  if (plan.trial_days === 0) {
    dueToday = plan.price;
    dueLater = undefined;
  }

  return (
    <div className={classes.container}>
      <div className={classes.inner}>
        <div className={classes.row}>
          <span>Due Today</span>
          <span>A${dueToday}</span>
        </div>
        {dueLater &&
          <div className={classes.row}>
            <span>Due {billingDate}</span>
            <span>A${dueLater}</span>
          </div>
        }
      </div>
    </div>
  );
};

PlanSummary.propTypes = {
  plan: PropTypes.object,
};

export default PlanSummary;
